import { useQuery } from '@tanstack/react-query';
import * as healthApi from '../../api/health';

// Re-export for consumers
export type { MaintenanceSeverity } from '../../api/health';

export const healthKeys = {
    all: ['health', 'public'] as const,
};

export const useHealth = () => {
    return useQuery({
        queryKey: healthKeys.all,
        queryFn: healthApi.getHealth,
        refetchInterval: 60000, // Check every minute
    });
};
